import { bannerDataList } from '../lib/bannerData';
import { BannerData } from '../lib/bannerData';

interface BannerTitleProps {
  currentBanner: BannerData;
}

const BannerTitle = ({ currentBanner }: BannerTitleProps) => {
  return (
    <div className='typography-ui-32b sm:typography-ui-56b mb-[16px] w-full text-gray-900 sm:mb-[24px]'>
      <div className='relative h-[40px] overflow-hidden sm:h-[70px]'>
        {bannerDataList.map((banner, index) => (
          <span
            key={banner.id}
            className='gif absolute block w-full text-left text-primary-700'
            id={index === 0 ? undefined : `g${index + 1}`}
          >
            {banner.title}
          </span>
        ))}
      </div>
      <span className='text-gray-900'>{currentBanner.subtitle}</span>
    </div>
  );
};

export default BannerTitle;
